
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3NQOU", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $b6785f1d81c92020$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $gLm0b = parcelRequire("gLm0b");

var $6r14Z = parcelRequire("6r14Z");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $hZy36 = parcelRequire("hZy36");

var $3H7QB = parcelRequire("3H7QB");

var $hp3ar = parcelRequire("hp3ar");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-4ede2369cf";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
(0, $hZy36.configureCastle)();
const $b6785f1d81c92020$var$SUPPORTED_LOCALES = [
    {
        hrefLang: 'ja',
        langRoute: 'ja'
    },
    {
        hrefLang: 'fr',
        langRoute: 'fr'
    },
    {
        hrefLang: 'de',
        langRoute: 'de'
    },
    {
        hrefLang: 'es',
        langRoute: 'es'
    },
    {
        hrefLang: 'pt-BR',
        langRoute: 'br'
    },
    {
        hrefLang: 'zh-Hans',
        langRoute: 'zh'
    },
    {
        hrefLang: 'ko',
        langRoute: 'ko'
    },
    {
        hrefLang: 'ru',
        langRoute: 'ru'
    },
    {
        hrefLang: 'pl',
        langRoute: 'pl'
    },
    {
        hrefLang: 'it',
        langRoute: 'it'
    },
    {
        hrefLang: 'nl',
        langRoute: 'nl'
    }
];
const $b6785f1d81c92020$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== 'undefined' && window.IS_STATIC;
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== 'undefined') locationData = {
        countryIsoCode: window.countryCode || '',
        regionIsoCode: window.regionIsoCode || ''
    };
    // In Uniform Playground (preview authoring environment), skip OneTrust check
    // and assume performance tracking is enabled — mirrors OneTrustProvider behavior.
    // Cookies are unavailable in the cross-origin iframe context, so the normal
    // cookie-based check always returns false for CPRA users (e.g. California).
    const isPerfOnetrustEnabled = window.isUniformPlayground || (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== 'undefined' ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $hp3ar.isEdgeCachingPath)(window.location)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(async ()=>{
        try {
            await (0, $3H7QB.DynamicConfigClient).getInstance().initialize({
                bootstrapValues: window.featureGateBootstrapValues
            });
        } catch (error) {
            console.error('Failed to initialize DynamicConfigClient', error);
        }
        const canonicalBaseUrl = (0, $6r14Z.getCanonicalBaseUrl)(window.location.hostname, path);
        const pathForCanonical = path ? (0, $6r14Z.canonicalPathForHref)(canonicalBaseUrl, path) : undefined;
        const route = pathForCanonical === undefined ? '' : pathForCanonical === '' ? '' : `/${pathForCanonical}`;
        const page = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "canonical",
                    href: `${canonicalBaseUrl}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "alternate",
                    href: `${canonicalBaseUrl}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $b6785f1d81c92020$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${canonicalBaseUrl}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    compositionRegenerationMetadata: window._uniformRegenerationMetadata,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    channel: window.channel,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-expect-error type
            const root = (0, $konOj.createRoot)(document.getElementById('wac'));
            root.render(page);
        } else // @ts-expect-error type
        (0, $konOj.hydrateRoot)(document.getElementById('wac-root'), page, {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById('wac-root')?.setAttribute('hydration-error', 'true');
            }
        });
    });
};

});

parcelRegister("5AtlP", function(module, exports) {
$parcel$export(module.exports, "getFirstName", function () { return $f5b50bde618a4cd3$export$cf3a9fa4cebe2986; });
function $f5b50bde618a4cd3$export$cf3a9fa4cebe2986(fullName = '') {
    return fullName.trim().split(' ')[0] || '';
}

});

parcelRegister("j2b52", function(module, exports) {
$parcel$export(module.exports, "ClientOnly", function () { return $1445362815fc2039$export$70f10949f62d7670; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
let $1445362815fc2039$var$hydrating = true;
function $1445362815fc2039$export$1b590bd8f758497b() {
    const [hydrated, setHydrated] = (0, $1oC0p.useState)(()=>!$1445362815fc2039$var$hydrating);
    (0, $1oC0p.useEffect)(function hydrate() {
        $1445362815fc2039$var$hydrating = false;
        console.debug('hydrating:', $1445362815fc2039$var$hydrating);
        setHydrated(true);
    }, []);
    return hydrated;
}
const $1445362815fc2039$export$70f10949f62d7670 = ({ children: children })=>{
    return $1445362815fc2039$export$1b590bd8f758497b() ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: children
    }) : null;
};

});

parcelRegister("hra1O", function(module, exports) {
function $cb1cbcadfcc5a111$export$2e2bcd8739ae039(r) {
    throw new TypeError('"' + r + '" is read-only');
}

});

parcelRegister("hrBjL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e29ae4526453fe67eff894ad5ac76ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb31e7ce97688c96$var$_react = $cb31e7ce97688c96$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $cb31e7ce97688c96$var$_baseNew = $cb31e7ce97688c96$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $cb31e7ce97688c96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb31e7ce97688c96$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $cb31e7ce97688c96$var$_react.default.createElement($cb31e7ce97688c96$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0m-2.174-2.52-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$cb31e7ce97688c96$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $cb31e7ce97688c96$var$_default = module.exports.default = $cb31e7ce97688c96$var$CheckCircleIcon;

});

parcelRegister("erWD3", function(module, exports) {

var $ih96c = parcelRequire("ih96c");

var $ez49H = parcelRequire("ez49H");

var $i5LOB = parcelRequire("i5LOB");
/** Error message constants. */ var $a85110cf61019b06$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a85110cf61019b06$var$nativeMax = Math.max, $a85110cf61019b06$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $a85110cf61019b06$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($a85110cf61019b06$var$FUNC_ERROR_TEXT);
    wait = $i5LOB(wait) || 0;
    if ($ih96c(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $a85110cf61019b06$var$nativeMax($i5LOB(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $a85110cf61019b06$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $ez49H();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($ez49H());
    }
    function debounced() {
        var time = $ez49H(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $a85110cf61019b06$var$debounce;

});
parcelRegister("ez49H", function(module, exports) {

var $bBiRC = parcelRequire("bBiRC");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $a9a78ebf45cce892$var$now = function() {
    return $bBiRC.Date.now();
};
module.exports = $a9a78ebf45cce892$var$now;

});

parcelRegister("i5LOB", function(module, exports) {

var $cwhLk = parcelRequire("cwhLk");

var $ih96c = parcelRequire("ih96c");

var $7K8RW = parcelRequire("7K8RW");
/** Used as references for various `Number` constants. */ var $0366286619144970$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $0366286619144970$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $0366286619144970$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $0366286619144970$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $0366286619144970$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $0366286619144970$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($7K8RW(value)) return $0366286619144970$var$NAN;
    if ($ih96c(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $ih96c(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $cwhLk(value);
    var isBinary = $0366286619144970$var$reIsBinary.test(value);
    return isBinary || $0366286619144970$var$reIsOctal.test(value) ? $0366286619144970$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $0366286619144970$var$reIsBadHex.test(value) ? $0366286619144970$var$NAN : +value;
}
module.exports = $0366286619144970$var$toNumber;

});
parcelRegister("cwhLk", function(module, exports) {

var $km1La = parcelRequire("km1La");
/** Used to match leading whitespace. */ var $91d64068929a6877$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $91d64068929a6877$var$baseTrim(string) {
    return string ? string.slice(0, $km1La(string) + 1).replace($91d64068929a6877$var$reTrimStart, '') : string;
}
module.exports = $91d64068929a6877$var$baseTrim;

});
parcelRegister("km1La", function(module, exports) {
/** Used to match a single whitespace character. */ var $ed173a2bc5e60c5a$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $ed173a2bc5e60c5a$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $ed173a2bc5e60c5a$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $ed173a2bc5e60c5a$var$trimmedEndIndex;

});




parcelRegister("cG7vk", function(module, exports) {
$parcel$export(module.exports, "getConsents", function () { return $cfc06dcc6844c6fb$export$aa1c769485f00255; });
const $cfc06dcc6844c6fb$export$aa1c769485f00255 = (locale, localeRequiresMarketingCommunicationOptIn = false, privacyPolicy = '')=>{
    //TO DO: Get signup to remove this payload reqirement as this is NOT shown to the user
    return {
        site: 'atlassian',
        locale: locale,
        formUrl: window.location.href,
        consents: [
            {
                key: 'termsOfService',
                // showing "" as we do not show anything to the user
                displayedText: '',
                granted: true
            },
            {
                key: 'privacyPolicy',
                displayedText: privacyPolicy,
                granted: true
            },
            {
                key: 'generalMarketingOptIn',
                // showing "" as we do not show anything to the user
                displayedText: '',
                granted: !localeRequiresMarketingCommunicationOptIn
            }
        ]
    };
};

});

parcelRegister("36RSw", function(module, exports) {
$parcel$export(module.exports, "getSignupContext", function () { return $2dcb0771ea012f74$export$d0b488e11359b5d1; });

var $3L8ZR = parcelRequire("3L8ZR");

var $dpiFM = parcelRequire("dpiFM");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $2gCne = parcelRequire("2gCne");

var $fcO7r = parcelRequire("fcO7r");

var $gPKCY = parcelRequire("gPKCY");
function $2dcb0771ea012f74$export$d0b488e11359b5d1({ productKey: productKey, testingPurposes: testingPurposes, signupId: signupId, search: search, locale: locale }) {
    const searchParameters = new URLSearchParams(search);
    const templateId = searchParameters.get('templateId');
    const publicLinkId = searchParameters.get('publicLinkId');
    const signupContext = {};
    if (templateId) Object.assign(signupContext, {
        templateId: templateId
    });
    if (testingPurposes) Object.assign(signupContext, {
        testingPurposes: true
    });
    if (signupId) Object.assign(signupContext, {
        signupId: signupId
    });
    const anchorLocalStorage = (0, $2gCne.getLocalStorage)('onboarding-journey');
    if (anchorLocalStorage) try {
        (0, $gPKCY.ufoEventBxpGatewayAnchorParse).start({
            productKey: productKey,
            webPlatform: 'bxp-ui'
        });
        const localStorageObj = JSON.parse(anchorLocalStorage);
        if (localStorageObj) {
            const bxpGatewayAnchor = {
                anchor: localStorageObj.anchor?.name,
                type: localStorageObj.anchor?.type,
                team: localStorageObj.team,
                persona: localStorageObj.persona,
                keyword: localStorageObj.keyword,
                timestamp: new Date()
            };
            Object.assign(signupContext, {
                bxpGatewayAnchor: bxpGatewayAnchor
            });
        }
        (0, $gPKCY.ufoEventBxpGatewayAnchorParse).success({
            customData: {
                reactComponent: 'getSignupContext',
                analyticsEvent: 'succeeded'
            }
        });
    } catch (error) {
        (0, $gPKCY.ufoEventBxpGatewayAnchorParse).failure({
            customData: {
                reactComponent: 'getSignupContext',
                analyticsEvent: 'error',
                anchorLocalStorage: anchorLocalStorage
            },
            error: error
        });
    }
    const confluencePublicLinkEnabled = (0, $3L8ZR.default).checkGate((0, $dpiFM.StatsigFeatureGateKey).BXPSU_2854_CONFLUENCE_PUBLIC_LINK);
    if (productKey === (0, $fcO7r.ProductKey).CONFLUENCE && publicLinkId && confluencePublicLinkEnabled) Object.assign(signupContext, {
        publicLinkId: decodeURIComponent(publicLinkId)
    });
    if (locale && (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).passLocaleInSignupContext)) Object.assign(signupContext, {
        locale: locale
    });
    return signupContext;
}

});
parcelRegister("dpiFM", function(module, exports) {
$parcel$export(module.exports, "StatsigFeatureGateKey", function () { return $21861e1c4b9bb1e3$export$8af921d6e42706ad; });
var $21861e1c4b9bb1e3$export$8af921d6e42706ad = /*#__PURE__*/ function(StatsigFeatureGateKey) {
    StatsigFeatureGateKey["BXPSU_2854_CONFLUENCE_PUBLIC_LINK"] = "bxpsu-2854_confluence_public_link"; // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/bxpsu-2854_confluence_public_link
    return StatsigFeatureGateKey;
}({});
var $21861e1c4b9bb1e3$export$111c3eba7363bcc7 = /*#__PURE__*/ function(StatsigExperimentKey) {
    StatsigExperimentKey["WAC_SIGNUP_UPGRADE_PATH"] = "wac_signup_upgrade_path";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/wac_signup_upgrade_path
    StatsigExperimentKey["JFIND_COMPANY_EXPAND_IMPACT"] = "jfind-company-expand-impact";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-company-expand-impact
    StatsigExperimentKey["JFIND_PAID_GET_USERS_BACK_TO_PRODUCT"] = "jfind-get-users-back-to-product-for-paid";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-get-users-back-to-product-for-paid/setup
    StatsigExperimentKey["JFIND_REDIRECT_TO_PRODUCT_V2"] = "jfind-redirect-logged-in-users-to-product-v2"; //https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-redirect-logged-in-users-to-product-v2/setup
    return StatsigExperimentKey;
}({});
var $21861e1c4b9bb1e3$export$49182666c899d264 = /*#__PURE__*/ function(StatsigExperimentCohort) {
    StatsigExperimentCohort["CONTROL"] = "control";
    StatsigExperimentCohort["UNEXPECTED_FAILURE"] = "unexpected_failure";
    StatsigExperimentCohort["NOT_ENROLLED"] = "not_enrolled";
    StatsigExperimentCohort["WAC_SIGNUP_UPGRADE_PATH_TEST"] = "test";
    StatsigExperimentCohort["JFIND_COMPANY_EXPAND_IMPACT_VARIANT"] = "jfind-company-expand-impact";
    StatsigExperimentCohort["JFIND_REDIRECT_TO_PRODUCT_V2_CONTROL"] = "control";
    StatsigExperimentCohort["JFIND_REDIRECT_TO_PRODUCT_V2_VARIANT"] = "variant";
    StatsigExperimentCohort["JFIND_PAID_GET_USERS_BACK_TO_PRODUCT_CONTROL"] = "control";
    StatsigExperimentCohort["JFIND_PAID_GET_USERS_BACK_TO_PRODUCT_VARIANT"] = "variation";
    return StatsigExperimentCohort;
}({});

});


parcelRegister("9EuLB", function(module, exports) {
$parcel$export(module.exports, "isTestTenantByName", function () { return $ff00a0ebc0b5c261$export$293bc70a1f725926; });

var $kNE9Z = parcelRequire("kNE9Z");
const $ff00a0ebc0b5c261$export$293bc70a1f725926 = (siteName)=>{
    if ((0, $kNE9Z.isProduction)()) return false;
    const TEST_TENANT_PATTERN = /^atl-vertigo--(((?:jira|j|rolex|stg)+-jira-branch-[^-]+--)|(conf-(conf|stg)-proxy-\w+--[\w-]+)).*$/;
    const SHORT_TEST_TENANT_PATTERN = /^atl-vertigo--jira-(jes|jed)-[^-]+--.*$/;
    return TEST_TENANT_PATTERN.test(siteName) || SHORT_TEST_TENANT_PATTERN.test(siteName) || siteName.includes('polli.signup');
};

});

parcelRegister("6e3tU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4886c0393fe869b5$var$_react = $4886c0393fe869b5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4886c0393fe869b5$var$_baseNew = $4886c0393fe869b5$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $4886c0393fe869b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4886c0393fe869b5$var$CommentIcon = (props)=>/*#__PURE__*/ $4886c0393fe869b5$var$_react.default.createElement($4886c0393fe869b5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$4886c0393fe869b5$var$CommentIcon.displayName = 'CommentIcon';
var $4886c0393fe869b5$var$_default = module.exports.default = $4886c0393fe869b5$var$CommentIcon;

});

parcelRegister("cNamI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5f93e34be6622a1cb8208e9984b09a45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $950219ff5e98641d$var$_react = $950219ff5e98641d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $950219ff5e98641d$var$_baseNew = $950219ff5e98641d$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $950219ff5e98641d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $950219ff5e98641d$var$LightbulbIcon = (props)=>/*#__PURE__*/ $950219ff5e98641d$var$_react.default.createElement($950219ff5e98641d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$950219ff5e98641d$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $950219ff5e98641d$var$_default = module.exports.default = $950219ff5e98641d$var$LightbulbIcon;

});

parcelRegister("5tLnS", function(module, exports) {
$parcel$export(module.exports, "useDeferSiteNamingContinueUrl", function () { return $202faeefc4f73a47$export$a0ddbbade87631d7; });

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $fcO7r = parcelRequire("fcO7r");

var $gZgIU = parcelRequire("gZgIU");

var $7GVWk = parcelRequire("7GVWk");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");
// The experiment targets Jira Software only — matches the `useLoggedOutJira`
// cohort in the experiment manifest. If we ever expand to JSM / JPD, add
// their product keys here and update the experiment's cohort accordingly.
const $202faeefc4f73a47$var$JIRA_PRODUCT_KEYS = [
    (0, $fcO7r.ProductKey).JIRA_SOFTWARE
];
const $202faeefc4f73a47$export$a0ddbbade87631d7 = ()=>{
    const { product: product, edition: edition } = (0, $7GVWk.useUserContext)();
    const { locale: locale } = (0, $8e22h.default)();
    const deferSiteNamingExperiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).d1d6DeferSiteNaming);
    const isEnrolledInVariant = deferSiteNamingExperiment.type === 'enrolled' && deferSiteNamingExperiment.value;
    // Fire the Statsig exposure for BOTH arms (control and variant) here, at the
    // signup form. This is the single divergence point where the user is still
    // logged out and therefore still satisfies the experiment's `useLoggedOutJira`
    // cohort, so `useExperiment` reports `enrolled` and `fireExposure()` actually
    // emits. It is the ONLY place the exposure can fire correctly: every
    // downstream divergent surface — the control site-naming page
    // (`LoggedInJiraNewUser`) and the variant `DeferSiteNamingGate` on the
    // confirmation page — renders AFTER account creation, where the user is
    // logged in, the cohort no longer holds, and `fireExposure()` silently
    // no-ops. The ref guard keeps this to a single fire across Strict Mode
    // double-invokes and re-renders.
    const hasFiredExposureRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(()=>{
        if (hasFiredExposureRef.current) return;
        if (deferSiteNamingExperiment.type !== 'enrolled') return;
        hasFiredExposureRef.current = true;
        deferSiteNamingExperiment.fireExposure();
    }, [
        deferSiteNamingExperiment
    ]);
    return (0, $1oC0p.useCallback)(()=>{
        // Bail early for control, non-enrolled, missing product, or non-Jira products.
        // Keeping `product` in the predicate gives TS the narrowing it needs below.
        if (!isEnrolledInVariant || !product || !$202faeefc4f73a47$var$JIRA_PRODUCT_KEYS.includes(product.key)) return undefined;
        return (0, $gZgIU.getDeferSiteNamingConfirmationPageUrl)({
            productKey: product.key,
            edition: edition ?? 'free',
            locale: locale
        });
    }, [
        product,
        edition,
        isEnrolledInVariant,
        locale
    ]);
};

});

parcelRegister("aUEBX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7de7c2be3f7c9d9cc79e629bb0768f3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f1ea2e2c453dc33$var$_react = $7f1ea2e2c453dc33$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7f1ea2e2c453dc33$var$_baseNew = $7f1ea2e2c453dc33$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $7f1ea2e2c453dc33$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Timeline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for timelines in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f1ea2e2c453dc33$var$TimelineIcon = (props)=>/*#__PURE__*/ $7f1ea2e2c453dc33$var$_react.default.createElement($7f1ea2e2c453dc33$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11 2.5H1V1h10zm4 4.167H5v-1.5h10zm-4 4.167H1v-1.5h10zM15 15H5v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$7f1ea2e2c453dc33$var$TimelineIcon.displayName = 'TimelineIcon';
var $7f1ea2e2c453dc33$var$_default = module.exports.default = $7f1ea2e2c453dc33$var$TimelineIcon;

});

parcelRegister("8AXar", function(module, exports) {
$parcel$export(module.exports, "SignupBackgroundLayout", function () { return $3bb8ea39c6cdcf07$export$704c9f0bd9ea3790; });
/* signup-background-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $5YGzb = parcelRequire("5YGzb");
const $3bb8ea39c6cdcf07$export$704c9f0bd9ea3790 = ({ ProductLogo: ProductLogo, children: children, theme: theme })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _zulp10yn _6a6z1h6o _2z051mfv _1itkuprl _bfhkvuon _1lrw10hx _ouxlbbky _12vemgnk _1tke1kxc _ca0q12am _u5f3idpf _n3td53f4 _19bvidpf _v5641i9m _9szs1kz8",
            theme === 'yellow' && "_1itkhe6p",
            theme === 'green' && "_1itkiyjd"
        ]),
        children: [
            ProductLogo,
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhkvuon _2rko1crf _vchh1ntv _syazazsu _1e0c1txw _2lx21bp4 _ect4b1j9 _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f13pj _ca0q1j6v _u5f31j6v _n3td1j6v _19bv1j6v _1bsb1kdj _scbp1jkq _oqic1ylp _1rmjys9h _cjbt1ylp _pnmbys9h _19451lk4"
                    ]),
                    children: children
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5YGzb.AtlassianLogo), {
                appearance: "neutral",
                size: "small",
                testId: "atlassian-logo",
                label: "Atlassian logo"
            })
        ]
    });
};
const $3bb8ea39c6cdcf07$var$containerStyles = null;
const $3bb8ea39c6cdcf07$var$yellowThemeCss = null;
const $3bb8ea39c6cdcf07$var$greenThemeCss = null;
const $3bb8ea39c6cdcf07$var$formWrapperCss = null;

});


var $3NQOU = parcelRequire("3NQOU");

var $7R96I = parcelRequire("7R96I");
(0, $3NQOU.init)((0, $7R96I.SignupPage));


//# sourceMappingURL=signup-page.012e551e.js.map
